export const giftCardReviews = [
  {
    name: "Beth",
    value: 10,
    info: "Cuban Salsa for Beginners",
    reviewTxt:
      "Excellent teachers. Friendly, patient and so positive with those who straggle-struggled behind. Very attentive and helpful at every step. SUCH a fun dance class, such good value for money....even for absolute beginners like me and my Mum. We had been wanting to take a dance class for ages and this was totally worth it! Highly recommend!",
    url: "/cuban-salsa-for-beginners-1529605696",
    reviewValue: 10,
    totalBooking: 2,
    img: {
      src: "/static/images/landingpages/dance/user1.jpg"
    }
  },
  {
    name: "Max",
    value: 10,
    info: "Cuban Salsa for Beginners",
    reviewTxt:
      "The cuban salsa workshop was a lot of fun. There were only 4 of us so we got lots of individual attention. The time flew by. Carina, the teacher, gave clear instructions and inspired us to learn how to move those hips!",
    url: "/cuban-salsa-for-beginners-1529605696",
    reviewValue: 10,
    totalBooking: 3,
    img: {
      src: "/static/images/landingpages/dance/user2.jpg"
    }
  },
  {
    name: "Astrid",
    value: 10,
    info: "Cuban Salsa for Beginners",
    reviewTxt:
      "Really loved this class and Gabriela was an amazing teacher. She explained the background of cuban salsa thoroughly and allowed sufficient time to learn the basics. I'll be coming back!",
    url: "/cuban-salsa-for-beginners-1529605696",
    reviewValue: 9,
    totalBooking: 5,
    img: {
      src: "/static/images/landingpages/dance/user3.jpg"
    }
  }
];
